import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import BaseLink from 'shared/components/BaseLink'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

import './style.scss'

const BaseModal = props => {
  return (
    <Modal
      aria-labelledby={props.labelId}
      centered={props.centered}
      className={props.className}
      dialogClassName={props.dialogClassName}
      onHide={props.hideModal}
      show={props.show}
      size={props.size}
    >
      <Modal.Header>
        <Modal.Title id={props.labelId}>{props.title}</Modal.Title>
        <button
          type="button"
          className="close"
          onClick={props.hideModal}
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
          <span className="visually-hidden">Close</span>
        </button>
      </Modal.Header>
      <Modal.Body>{props.body ? <ReactMarkdown rehypePlugins={[rehypeRaw]}>{props.body}</ReactMarkdown> : props.children}</Modal.Body>
      {!!(props.sources || {}).length && (
        <Modal.Body>
          <p>Source(s):</p>
          <div className="modal-sources">
            {props.sources.map((source, index) => {
              return (
                <div key={`source-${index}`}>
                  {source.url ? (
                    <BaseLink className="text-link" href={source.url} text={source.text} />
                  ) : (
                    source.text
                  )}
                </div>
              )
            })}
          </div>
        </Modal.Body>
      )}
      <Modal.Body>
        {!!(props.documentationBody || (props.documentationSources || {}).length) && <p>Documentation(s):</p>}
        {props.documentationBody && <ReactMarkdown rehypePlugins={[rehypeRaw]}>{props.documentationBody}</ReactMarkdown>}
        {!!(props.documentationSources || {}).length && (
          <div className="modal-sources">
            {props.documentationSources.map((source, index) => {
              return (
                <div key={`source-${index}`}>
                  <BaseLink className="text-link" href={source.url} text={source.text} />
                </div>
              )
            })}
          </div>
        )}
      </Modal.Body>

      {props.modalFooter}
    </Modal>
  )
}

BaseModal.propTypes = {
  centered: PropTypes.bool,
  className: PropTypes.string,
  dialogClassName: PropTypes.string,
  labelId: PropTypes.string,
  modalFooter: PropTypes.object,
  hideModal: PropTypes.func,
  show: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string,
}

BaseModal.defaultProps = {
  className: 'modal',
  title: 'Modal Title',
  centered: true,
}

export default BaseModal
